import React from "react";
import {
  Mail,
  Phone,
  User,
  Building,
  Calendar,
  DollarSign,
  Clock,
  Award,
  GraduationCap,
  Heart,
  Shield,
  MapPin,
  Home,
  Flag,
  X,
} from "../../constants/icons";

  // ===== RESPONSIVE VIEW EMPLOYEE MODAL COMPONENT =====
  // ===== RESPONSIVE VIEW EMPLOYEE MODAL COMPONENT =====
  const ViewEmployeeModal = ({
    selectedEmployee = null,
    setShowViewEmployee = () => {},
    text = {},
    language = "en",
    screenSize = "md",
    styles = {},
    spacing = {},
    employeeProfilePics = {},
    getUserInitials = () => "",
    getStatusBadge = () => null,
    theme = "light",
    fonts = {},
  }) => {
    // Return null if no employee is selected
    if (!selectedEmployee) return null;

    // Provide default styles that match AddEmployeeModal look-and-feel
    const defaultStyles = {
      modal: {
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        backdropFilter: "blur(3px)",
        animation: "fadeIn 300ms ease-out",
      },
      viewModalContent: {
        position: "relative",
        width: "92%",
        maxWidth: 1000,
        maxHeight: "92vh",
        overflowY: "auto",
        background: theme === "dark"
          ? "linear-gradient(135deg, #0f172a 0%, #1a2a3a 100%)"
          : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
        color: theme === "dark" ? "#e6eef8" : "#0f172a",
        borderRadius: 16,
        padding: "32px",
        boxShadow: theme === "dark"
          ? "0 25px 60px rgba(0,0,0,0.8), 0 0 1px rgba(255,255,255,0.1)"
          : "0 20px 50px rgba(0,0,0,0.12), 0 0 1px rgba(0,0,0,0.04)",
        border: theme === "dark"
          ? "1px solid rgba(255,255,255,0.1)"
          : "1px solid rgba(148,163,184,0.15)",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        WebkitOverflowScrolling: "touch",
        animation: "slideUp 400ms cubic-bezier(0.34, 1.56, 0.64, 1)",
      },
      modalHeader: {
        marginBottom: 32,
        paddingBottom: 16,
        borderBottom: theme === "dark"
          ? "1px solid rgba(255,255,255,0.08)"
          : "1px solid rgba(0,0,0,0.08)",
        display: "flex",
        alignItems: "center",
        gap: 12,
        justifyContent: "space-between",
      },
      modalTitle: {
        margin: 0,
        fontSize: 24,
        fontWeight: 800,
        background: theme === "dark"
          ? "linear-gradient(135deg, #fff 0%, #cbd5e1 100%)"
          : "linear-gradient(135deg, #0f172a 0%, #0f172a 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        letterSpacing: "-0.5px",
        display: "flex",
        alignItems: "center",
        gap: 10,
      },
      closeBtn: {
        position: "absolute",
        top: 14,
        right: language === "ar" ? "auto" : 14,
        left: language === "ar" ? 14 : "auto",
        width: 40,
        height: 40,
        borderRadius: 10,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: theme === "dark" ? "rgba(13, 18, 28, 0.15)" : "rgba(255,255,255,0.92)",
        border: theme === "dark" ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(15,23,42,0.06)",
        cursor: "pointer",
        transition: "all 200ms ease",
        zIndex: 20,
        color: theme === "dark" ? "#94a3b8" : "#475569",
      },
      viewModalBody: { display: "flex", flexDirection: "column", gap: 20 },
      employeeHeader: {
        display: "flex",
        gap: 16,
        alignItems: "center",
        padding: "20px 0",
        borderBottom: theme === "dark" ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.08)",
        marginBottom: 8,
      },
      largeAvatar: {
        width: screenSize === "xs" ? 64 : 96,
        height: screenSize === "xs" ? 64 : 96,
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "#fff",
        fontWeight: 700,
        fontSize: screenSize === "xs" ? 20 : 28,
        flexShrink: 0,
      },
      employeeHeaderInfo: { flex: 1 },
      employeeName: { fontSize: screenSize === "xs" ? 18 : 22, fontWeight: 800, margin: "0 0 4px 0", color: theme === "dark" ? "#fff" : "#0f172a" },
      employeeTitle: { margin: "0 0 2px 0", fontSize: 14, color: theme === "dark" ? "#94a3b8" : "#475569" },
      employeeDepartment: { margin: 0, fontSize: 13, color: theme === "dark" ? "#60a5fa" : "#1e40af", fontWeight: 600 },
      employeeStatus: { marginTop: 8 },
      infoSection: {
        marginTop: 4,
        padding: "16px",
        background: theme === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)",
        borderRadius: 12,
        border: theme === "dark" ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.05)",
      },
      sectionHeader: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontWeight: 800,
        fontSize: 13,
        color: theme === "dark" ? "#60a5fa" : "#1e40af",
        borderLeft: theme === "dark" ? "3px solid rgba(96,165,250,0.6)" : "3px solid #3b82f6",
        paddingLeft: 10,
        marginBottom: 14,
        textTransform: "uppercase",
        letterSpacing: "0.6px",
      },
      infoGrid: {
        display: "grid",
        gridTemplateColumns: screenSize === "xs" ? "1fr" : screenSize === "sm" ? "repeat(2,1fr)" : "repeat(3,1fr)",
        gap: 16,
      },
      infoItem: {
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        padding: "10px 12px",
        borderRadius: 8,
        background: theme === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)",
        border: theme === "dark" ? "1px solid rgba(255,255,255,0.05)" : "1px solid rgba(0,0,0,0.04)",
      },
      infoLabel: { fontSize: 11, fontWeight: 700, color: theme === "dark" ? "#94a3b8" : "#475569", marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.5px" },
      infoValue: { fontSize: 14, fontWeight: 500, color: theme === "dark" ? "#e6eef8" : "#0f172a" },
    };

    // merge passed styles over defaults (empty {} by default so defaultStyles win)
    styles = { ...defaultStyles, ...(styles || {}) };

    // ✅ FIX: Safely access fullEmployeeData with fallback
    const employeeData = selectedEmployee.fullEmployeeData || {};

    // Function to format date strings
    const formatDate = (dateString) => {
      if (!dateString) return text[language].na;
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: screenSize === "xs" ? "short" : "long",
        day: "numeric",
      });
    };
    // Handle clicking outside modal to close it
    const handleModalClick = (e) => {
      if (e.target === e.currentTarget) {
        setShowViewEmployee(false);
      }
    };

    // Function to format currency amounts
    const formatCurrency = (amount) => {
      if (!amount || amount === 0) return text[language].na;
      return `$${amount.toLocaleString()}`;
    };

    // Return modal JSX
    return (
      <div style={styles.modal} onClick={handleModalClick}>
        <div style={styles.viewModalContent}>
          {/* Modal Header */}
          <div style={styles.modalHeader}>
            <h2 style={styles.modalTitle}>{text[language].employeeDetails}</h2>
            <button style={styles.closeBtn} onClick={() => setShowViewEmployee(false)} title={text[language].close || 'Close'}>
              <X size={screenSize === "xs" ? 18 : 20} />
            </button>
          </div>

          {/* Modal Body */}
          <div style={styles.viewModalBody}>
            {/* Employee Header Section */}
            {/* Employee Header Section */}
            <div style={{
              ...styles.employeeHeader,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              textAlign: language === 'ar' ? 'right' : 'left'
            }}>
              {/* ✅ Container للصورة والاسم في صف واحد */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: language === 'ar' ? 0 : spacing.margin,
                gap: spacing.margin,
                flex: 1
              }}>
                {/* الصورة الشخصية */}
                {employeeProfilePics[selectedEmployee.id] ? (
                  <img
                    src={employeeProfilePics[selectedEmployee.id]}
                    alt={selectedEmployee.name}
                    style={{
                      ...styles.largeAvatar,
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}

                <div
                  style={{
                    ...styles.largeAvatar,
                    display: employeeProfilePics[selectedEmployee.id] ? 'none' : 'flex'
                  }}
                >
                  {getUserInitials(selectedEmployee?.name)}
                </div>

                {/* معلومات الموظف */}
                <div style={{
                  ...styles.employeeHeaderInfo,
                  textAlign: language === 'ar' ? 'right' : 'left'
                }}>
                  <h3 style={styles.employeeName}>
                    {(() => {
                      const displayName = language === "ar"
                        ? (selectedEmployee?.arabicName || selectedEmployee?.name)
                        : selectedEmployee?.name;

                      if (language === "ar") {
                        // إذا الاسم العربي موجود وغير فارغ اعرضه كاملاً
                        if (displayName && displayName.trim()) {
                          return displayName.trim();
                        }
                        return text[language].na;
                      } else {
                        // في الإنجليزي اعرض أول ثلاث كلمات فقط
                        if (displayName && displayName.trim()) {
                          return displayName.trim().split(/\s+/).slice(0, 3).join(" ");
                        }
                        return text[language].na;
                      }
                    })()}
                  </h3>
                  <p style={styles.employeeTitle}>{selectedEmployee?.position}</p>
                  {/* <p style={styles.employeeDepartment}>
                    {selectedEmployee?.department}
                  </p> */}
                </div>
              </div>

              {/* Status Badge on the Right */}
              <div style={{
                ...styles.employeeStatus,
                marginLeft: 'auto',
                marginRight: 50,
                marginTop: 0
              }}>
                {getStatusBadge(selectedEmployee?.status)}
              </div>
            </div>          <div style={styles.infoSection}>
              <h4 style={styles.sectionHeader}>
                <Mail size={screenSize === "xs" ? 16 : 18} />
                {text[language].contactInformation}
              </h4>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <Mail size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>{text[language].email}</p>
                    <p style={styles.infoValue}>{selectedEmployee?.email || text[language].na}</p>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Phone size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>{text[language].phone}</p>
                    <p style={styles.infoValue}>{selectedEmployee?.phone || text[language].na}</p>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <User size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>{text[language].nationalId}</p>
                    <p style={styles.infoValue}>
                      {employeeData?.nationalId || text[language].na}
                    </p>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Phone size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>
                      {text[language].emergencyPhone}
                    </p>
                    <p style={styles.infoValue}>
                      {employeeData?.emergencyPhoneNumber || text[language].na}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Work Information Section */}
            <div style={styles.infoSection}>
              <div style={styles.sectionHeader}>
                <Building size={screenSize === "xs" ? 16 : 18} />
                <span>{text[language].workInformation}</span>
              </div>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <Building size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>{text[language].company}</div>
                    <div style={styles.infoValue}>
                      {selectedEmployee.company || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Calendar size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].hiringDate}
                    </div>
                    <div style={styles.infoValue}>
                      {formatDate(selectedEmployee.joinDate)}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <DollarSign size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].netSalary}
                    </div>
                    <div style={styles.infoValue}>
                      {formatCurrency(selectedEmployee.salary)}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Clock size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].workingExperience}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.workingAgeYears || 0}{" "}
                      {text[language].years},{" "}
                      {employeeData.workingAgeMonths || 0}{" "}
                      {text[language].months}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Award size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>{text[language].laborMode}</div>
                    <div style={styles.infoValue}>
                      {employeeData.laborMode || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Calendar size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].contractDate}
                    </div>
                    <div style={styles.infoValue}>
                      {formatDate(employeeData.contractDate)}
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* Additional Work Details Section */}
            <div style={styles.infoSection}>
              <h4 style={styles.sectionHeader}>
                <DollarSign size={screenSize === "xs" ? 16 : 18} />
                Additional Compensation
              </h4>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <DollarSign size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>Transportation Allowances</p>
                    <p style={styles.infoValue}>
                      {formatCurrency(employeeData.transportationAllowances)}
                    </p>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <DollarSign size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>Variable Salary</p>
                    <p style={styles.infoValue}>
                      {formatCurrency(employeeData.variableSalary)}
                    </p>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Building size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>Working Company</p>
                    <p style={styles.infoValue}>
                      {employeeData.workingCompany || text[language].na}
                    </p>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Award size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <p style={styles.infoLabel}>Labor Mode</p>
                    <p style={styles.infoValue}>
                      {employeeData.laborMode || text[language].na}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Personal Information Section */}
            <div style={styles.infoSection}>
              <div style={styles.sectionHeader}>
                <Home size={screenSize === "xs" ? 16 : 18} />
                <span>{text[language].personalInformation}</span>
              </div>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <MapPin size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>{text[language].address}</div>
                    <div style={styles.infoValue}>
                      {employeeData.address || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <MapPin size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>{text[language].city}</div>
                    <div style={styles.infoValue}>
                      {employeeData.city || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Flag size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>{text[language].country}</div>
                    <div style={styles.infoValue}>
                      {employeeData.country || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Flag size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].nationality}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.nationality || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Heart size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].maritalStatus}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.maritalStatus || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <User size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>{text[language].gender}</div>
                    <div style={styles.infoValue}>
                      {employeeData.gender || text[language].na}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Education Information Section */}
            <div style={styles.infoSection}>
              <div style={styles.sectionHeader}>
                <GraduationCap size={screenSize === "xs" ? 16 : 18} />
                <span>{text[language].educationInformation}</span>
              </div>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <GraduationCap size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].graduateInstitution}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.graduateInstitution || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Award size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>{text[language].major}</div>
                    <div style={styles.infoValue}>
                      {employeeData.major || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Calendar size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].graduationYear}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.graduationYear || text[language].na}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Insurance Information Section */}
            <div style={styles.infoSection}>
              <div style={styles.sectionHeader}>
                <Shield size={screenSize === "xs" ? 16 : 18} />
                <span>{text[language].insuranceInformation}</span>
              </div>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <Shield size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].insuranceStatus}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.insuranceStatus || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Shield size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].insuranceNumber}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.insuranceNumber || text[language].na}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <DollarSign size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].insuranceSalary}
                    </div>
                    <div style={styles.infoValue}>
                      {formatCurrency(employeeData.insuranceSalary)}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Calendar size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].insuranceStartDate}
                    </div>
                    <div style={styles.infoValue}>
                      {formatDate(employeeData.insuredBeginningDate)}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Clock size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].monthsForInsurance}
                    </div>
                    <div style={styles.infoValue}>
                      {employeeData.monthsForInsurance || text[language].na}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* System Information Section */}
            <div style={styles.infoSection}>
              <div style={styles.sectionHeader}>
                <Clock size={screenSize === "xs" ? 16 : 18} />
                <span>{text[language].systemInformation}</span>
              </div>
              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <User size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].employeeId}
                    </div>
                    <div style={styles.infoValue}>{selectedEmployee.id}</div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Calendar size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].createdAt}
                    </div>
                    <div style={styles.infoValue}>
                      {formatDate(employeeData.created_at)}
                    </div>
                  </div>
                </div>
                <div style={styles.infoItem}>
                  <Calendar size={screenSize === "xs" ? 14 : 16} />
                  <div>
                    <div style={styles.infoLabel}>
                      {text[language].lastUpdated}
                    </div>
                    <div style={styles.infoValue}>
                      {formatDate(employeeData.updated_at)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  };

export default ViewEmployeeModal;
